import type { OrganizationPlannerJobDetailsLocales } from '../types';

const organizationPlannerJobDetailsLocales: OrganizationPlannerJobDetailsLocales =
  {
    assignmentDetails: 'Assignment Details',
    assignments: 'Assignments',
    assignmentType: 'Assignment Type',
    basis: 'Basis',
    cancelOrder: 'Cancel Order',
    changeOrder: 'Change Order',
    comments: 'Comments',
    competencies: 'Competencies',
    dashboard: 'Dashboard',
    date: 'Date',
    documents: 'Documents',
    download: 'Download',
    downloadInvoice: 'Download Invoice',
    favoriteFreelancer: 'Favorite Freelancer',
    freelancer: 'Freelancer',
    hours: 'Hours',
    hoursCheckedBy: 'Hours Checked By',
    interestedUsers: 'Interested freelancers',
    invitedUsers: 'Invited freelancers',
    invoice: 'Invoice',
    invoiceDate: 'Invoice Date',
    invoices: 'Invoices',
    kvkNumber: 'KvK-number',
    location: 'Location',
    login: 'Login',
    logout: 'Logout',
    madeBy: 'Made By',
    noDocumentExist: 'No document exist',
    noUserHaveBeenInvited: 'No freelancers have been invited',
    noUserHaveShownInterest: 'No freelancers have shown interest',
    options: 'Options',
    orderCreated: 'Order Created',
    pause: 'Pause',
    perHourVAT: '€%{count} per hour (excl VAT)',
    phoneNumber: 'Phone number',
    review: {
      one: '%{count} review',
      other: '%{count} reviews',
      zero: 'no review yet',
    },
    settings: 'Settings',
    status: 'Status',
    time: 'Time',
    totalAmountTaxExcluded: 'Total Amount (excl. btw)',
    unfavoriteFreelancer: 'Unfavorite Freelancer',
    viewProfile: 'View Profile',
  };

export default organizationPlannerJobDetailsLocales;
